

import React from 'react'

export const SendSvg = () => {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24"  fill="white" ><polygon points="21.368 12.001 3 21.609 3 14 11 12 3 9.794 3 2.394"/></svg>
  )
}
